import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=52001814&scoped=true&"
import script from "./CommonDialog.vue?vue&type=script&lang=js&"
export * from "./CommonDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommonDialog.vue?vue&type=style&index=0&id=52001814&lange=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52001814",
  null
  
)

export default component.exports